module.exports = __webpack_public_path__ + "static/blog-placeholder-adbfca092085ed4edf426288bfb53c8e.png";